export default __webpack_public_path__ + "static/media/Thank_you_for.b94861d6.png";